import { render, staticRenderFns } from "./orderBar.vue?vue&type=template&id=b296df38&scoped=true&"
import script from "./orderBar.vue?vue&type=script&lang=js&"
export * from "./orderBar.vue?vue&type=script&lang=js&"
import style0 from "./orderBar.vue?vue&type=style&index=0&id=b296df38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b296df38",
  null
  
)

export default component.exports